import React from "react";
import { Footer, Navbar } from "../components";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/authContext";
import { Alert } from "../components/Alert";

const Register = () => {
  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const navigate = useNavigate();

  const { signup } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await signup(user.email, user.password);
      navigate("/");
    } catch (error) { 
      setError(error.message);
      if (error.code === "auth/internal-error"){
        setError("Correo invalido.");
      }
    }
  };

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">Registrarse</h1>
        <hr />
        <div class="row my-4 h-100">
          <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
            {error && <Alert message={error} />}
            <form onSubmit={handleSubmit}>
              <div class="form my-3">
                <label for="Email">Correo electrónico</label>
                <input
                  type="email"
                  class="form-control"
                  id="Email"
                  placeholder="name@ejemplo.com"
                  onChange={(e) => setUser({ ...user, email: e.target.value })}
                />
              </div>
              <div class="form  my-3">
                <label for="Password">Contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  id="Password"
                  placeholder="Password"
                  onChange={(e) =>
                    setUser({ ...user, password: e.target.value })
                  }
                />
              </div>
              <div className="my-3">
                <p>
                  ¿Ya tienes una cuenta?{" "}
                  <Link
                    to="/login"
                    className="text-decoration-underline text-info"
                  >
                    Acceder
                  </Link>{" "}
                </p>
              </div>
              <div className="text-center">
                <button class="my-2 mx-auto btn btn-dark" type="submit" onSubmit={handleSubmit}>
                  Registrar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Register;
